import React from 'react';
import {injectIntl} from "react-intl";
import {connect} from 'react-redux'
import './ConfigurationCheck.css'

class ConfigurationCheck extends React.Component {

  componentDidMount(){
    this.props.dispatchFetchDealerConfigurationCheck();
  }


  render() {
    return null;
  }
}

const mapStateToProps = state => ({
  dealerConfigurationCheck: state.dealerConfigurationCheck,
});

const mapDispatchToProps = dispatch => ({
  dispatchFetchDealerConfigurationCheck: () => dispatch({type: 'FETCH.DEALER_CONFIGURATION_CHECK.REQUEST'}),
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ConfigurationCheck));



